import React, { Component } from "react";
import { connectStore } from "redux-box";
import { module as ui } from "@st/ui";
import { module as documentFile } from "@st/documentFile";
import { id as modalIds } from "@c/common/GlobalModal";
import {
  MainBodyContentContainer,
  PlusButton,
  PlusIcon,
  InfiniteScrollParentContainer,
  InfiniteScrollLoader
} from "@sc/custom.styled";
import InfiniteScroll from "react-infinite-scroller";
import {
  Title,
  SectionHeader,
  SectionSubtext,
  ContentArea,
  CardGrid,
  Card,
  CardTitle,
  CardDescription,
  CardFooter,
  EditIcon,
  Badge,
  EmptyState,
  LoadingState
} from "./DocumentManagementView.styled";

class DocumentManagementView extends Component {
  componentDidMount() {
    this.props.documentFile.requestDocumentFileList(0);
  }

  fetchMoreDocuments = () => {
    const { documentFile } = this.props;
    if (documentFile.has_more) {
      setTimeout(() => {
        if (documentFile.next_page > 0) {
          documentFile.requestConcatDocumentFileList(documentFile.next_page);
        }
      }, 300);
    }
  };

  openCreateModal = () => {
    const { ui, documentFile } = this.props;
    documentFile.clearDocumentFileFormState();
    documentFile.setActiveDocumentFile(null);
    documentFile.setDocumentFileEditMode(false);
    ui.showModal(modalIds.DOCUMENT_MANAGEMENT_FORM);
  };

  openEditModal = (upload) => {
    const { ui, documentFile } = this.props;
    documentFile.clearDocumentFileFormState();
    documentFile.setActiveDocumentFile(upload);
    documentFile.setDocumentFileEditMode(true);
    ui.showModal(modalIds.DOCUMENT_MANAGEMENT_FORM);
  };

  render() {
    const { uploads, uploads_loading: loading, has_more } = this.props.documentFile;
    const baseUrl = window.location.hostname.split('.')[0] === 'admin' ? 'https://web.getfreadom.com/view/' : 'https://stage.web.getfreadom.com/view/'

    return (
      <MainBodyContentContainer primary>
        <SectionHeader>
          <div>
            <Title>Document Management</Title>
            <SectionSubtext>
              Manage secure document files, password protection, and access slugs.
            </SectionSubtext>
          </div>
        </SectionHeader>

        <ContentArea>
          {loading && uploads.length === 0 ? (
            <LoadingState>Loading documents...</LoadingState>
          ) : uploads.length > 0 ? (
            <InfiniteScrollParentContainer
              noTop
              position="relative"
              height="calc(100vh - 200px)"
              style={{ paddingBottom: '80px' }}
            >
              <InfiniteScroll
                pageStart={0}
                loadMore={this.fetchMoreDocuments}
                hasMore={has_more}
                style={{ position: "relative" }}
                loader={
                  <InfiniteScrollLoader className="loader" key={0}>
                    <img
                      alt="loader"
                      width="50"
                      height="50"
                      src={require("static/img/Theme-loader.gif")}
                    />
                  </InfiniteScrollLoader>
                }
                useWindow={false}
              >
                <CardGrid>
                  {uploads.map((item) => (
                    <Card key={item.id}>
                      <EditIcon
                        className="fa fa-pencil"
                        onClick={() => this.openEditModal(item)}
                      />
                      <CardTitle>{item.title}</CardTitle>
                      <CardDescription>
                        {item.description || "No description provided."}
                      </CardDescription>

                      <div style={{ marginBottom: '10px', fontSize: '13px' }}>
                        <strong>Type:</strong> {item.file_type || 'N/A'}
                      </div>
                      <div style={{ marginBottom: '15px', fontSize: '12px', wordBreak: 'break-all' }}>
                        <strong>S3 Link:</strong> <a href={item.s3_link} target="_blank" rel="noopener noreferrer">View File</a>
                      </div>
                      <div style={{ marginBottom: '15px', fontSize: '12px' }}>
                        <strong>Url:</strong> <a style={{ wordBreak: 'break-all' }} href={baseUrl + item.frontend_url} target="_blank" rel="noopener noreferrer">{baseUrl + item.frontend_url}</a>
                        <button style={{ cursor: 'pointer', backgroundColor: 'transparent', border: 'none' }} onClick={() => navigator.clipboard.writeText(baseUrl + item.frontend_url)}><i className="fa fa-copy"></i></button>
                      </div>

                      <CardFooter>
                        <span>{new Date(item.created_at).toLocaleDateString()}</span>
                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                          <Badge style={{
                            background: item.is_password_protected ? '#1890ff22' : '#52c41a22',
                            color: item.is_password_protected ? '#1890ff' : '#52c41a',
                            padding: '2px 8px',
                            borderRadius: '10px',
                            fontSize: '12px',
                          }}>
                            {item.is_password_protected ? '🔒 Protected' : '🔓 No Password'}
                          </Badge>
                          <Badge expired={item.is_expired}>
                            {item.is_expired ? "Expired" : "Active"}
                          </Badge>
                        </div>
                      </CardFooter>
                    </Card>
                  ))}
                </CardGrid>
              </InfiniteScroll>
            </InfiniteScrollParentContainer>
          ) : (
            <EmptyState>No documents found.</EmptyState>
          )}
        </ContentArea>

        <PlusButton hide={this.props.ui.show_modal} onClick={this.openCreateModal}>
          <PlusIcon
            primary
            alt="Plus Icon"
            cross={false}
            src={require("static/img/plusicon.png")}
          />
        </PlusButton>
      </MainBodyContentContainer>
    );
  }
}

export default connectStore({
  ui,
  documentFile,
})(DocumentManagementView);
